import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReserveService {

  constructor(private crudService: CrudService) { }
  Save(model: any): Observable<any> {
    return this.crudService.post<any>('api/Reserve/Save', model);
  }

  reserve(model: any): Observable<any> {
    debugger;
    return this.crudService.post<any>('api/Reserve/reservation', model);
  }

  ProceedToPayment(model: any): Observable<any> {
    debugger;
    return this.crudService.post<any>('api/Payment/SaveRequest', model);
  }
}
